var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h3',{staticClass:"c-title c-title--page-section"},[_vm._v(_vm._s(_vm.$t('participation.add')))]),_c('participant',{attrs:{"participantType":"clubMember"},on:{"submit":function($event){return _vm.update($event)},"cancel":function($event){return _vm.cancel()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }